var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.83822 9.52749L3.5594 9.52749C2.66868 9.52749 2.22243 8.45073 2.85203 7.82065L5.49043 5.18024C5.88091 4.78946 6.51428 4.78934 6.90491 5.17997L9.54533 7.82039C10.1753 8.45035 9.72913 9.52749 8.83822 9.52749Z","fill":"currentColor"}));
}

ChevronUp.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
